export const API_ERROR_MESSAGES = {
  NETWORK_ERROR: "Network Error"
};
export const MAX_API_RECALL_COUNT = 3;
